var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryLb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_9035)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_9035",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_9035)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.33333H28V0H0V5.33333Z",
    fill: "#F03340"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H28V14.6666H0V20Z",
    fill: "#F03340"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9428 12.3905C13.1585 12.1748 13.1585 11.8251 12.9428 11.6094L12.8661 11.5327C12.7424 11.409 12.5628 11.3593 12.3931 11.4017L12.0138 11.4965C11.5701 11.6074 11.2948 11.0289 11.6606 10.7545L12.0033 10.4975C12.2158 10.3381 12.1031 9.99996 11.8375 9.99996C11.5458 9.99996 11.453 9.60679 11.7139 9.47635L12.2861 9.19023C12.547 9.0598 12.4542 8.66663 12.1625 8.66663C11.8969 8.66663 11.7842 8.32849 11.9967 8.16912L13.6 6.96663C13.837 6.78885 14.163 6.78885 14.4 6.96663L16.0033 8.16912C16.2158 8.32849 16.1031 8.66663 15.8375 8.66663C15.5458 8.66663 15.453 9.0598 15.7139 9.19023L16.2861 9.47635C16.547 9.60679 16.4542 9.99996 16.1625 9.99996C15.8969 9.99996 15.7842 10.3381 15.9967 10.4975L16.3394 10.7545C16.7052 11.0289 16.4299 11.6074 15.9862 11.4965L15.6069 11.4017C15.4372 11.3593 15.2576 11.409 15.1339 11.5327L15.0572 11.6094C14.8415 11.8251 14.8415 12.1748 15.0572 12.3905C15.4051 12.7384 15.1587 13.3333 14.6667 13.3333H13.3333C12.8413 13.3333 12.5949 12.7384 12.9428 12.3905Z",
    fill: "#1FC065"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_9035"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryLb);
export default __webpack_public_path__ + "static/media/Country=LB.f4d7e5caef0538f7ad2a27c33dbddcab.svg";
export { ForwardRef as ReactComponent };